import {Dispatch, ThunkAction} from '../../../../../../../types/actions';
import {boardImportBoardJiraLearnMoreClickedSegmentEvent} from '../../../../../main/navigationPanel/effects/segmentEvents';

export const onClickJiraLearnMore = (): ThunkAction => {
    const action = (dispatch: Dispatch) => {
        dispatch(boardImportBoardJiraLearnMoreClickedSegmentEvent());
    };
    return action;
};
